import React, { useState, useEffect } from "react";
import Header from "../../common/restaurant/Header";
import Hero from "../../common/restaurant/Hero";
import Features from "../../common/restaurant/Features";
import About from "../../common/restaurant/About";
import Pricing from "../../common/restaurant/Pricing";
import Footer from "../../common/restaurant/Footer";
import BookingPage from "../../common/restaurant/BookingPage";

const RestaurantTemplate = ({ brandName, tagline, logo, colorTheme }) => {
  const [currentPage, setCurrentPage] = useState("home"); // State to track the current page

  const features = [
    {
      icon: "🍽️",
      title: "Delicious Menu",
      description: "Explore our diverse menu.",
    },
    {
      icon: "🏠",
      title: "Cozy Ambiance",
      description: "Enjoy a warm and inviting atmosphere.",
    },
    {
      icon: "⭐",
      title: "Top Reviews",
      description: "Rated 5 stars by our customers.",
    },
  ];

  const pricingPlans = [
    {
      name: "Basic Meal",
      price: "$10",
      features: ["1 Main Course", "1 Drink"],
      cta: "Order Now",
    },
    {
      name: "Family Pack",
      price: "$30",
      features: ["4 Main Courses", "4 Drinks"],
      cta: "Order Now",
    },
    {
      name: "Party Pack",
      price: "$100",
      features: ["10 Main Courses", "10 Drinks"],
      cta: "Order Now",
    },
  ];

  // Listen for URL hash changes
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1); // Remove the '#' from the hash
      if (hash === "booking") {
        setCurrentPage("booking");
      } else {
        setCurrentPage("home");
      }
    };

    // Check the initial hash on page load
    handleHashChange();

    // Add event listener for hash changes
    window.addEventListener("hashchange", handleHashChange);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  // Function to render the current page
  const renderPage = () => {
    if (currentPage === "booking") {
      return <BookingPage />;
    }
    return (
      <>
        <Hero
          title={brandName || "Restaurant Name"}
          tagline={tagline || "Taste the Difference"}
        />
        <Features features={features} />
        <About content="Welcome to our restaurant! We serve the best food in town with a cozy ambiance and top-notch service." />
        <Pricing plans={pricingPlans} />
      </>
    );
  };

  return (
    <div className={`min-h-screen bg-${colorTheme}-100`}>
      <Header
        logo={logo}
        brandName={brandName}
        onBookingClick={() => (window.location.hash = "booking")} // Update hash when booking is clicked
      />
      {renderPage()}
      <Footer brandName={brandName} />
    </div>
  );
};

export default RestaurantTemplate;
